import React from 'react'
import PayoutsContainer from 'containers/panel/admin/payouts-container'

const PayoutsPage = () => {
  return (
    <PayoutsContainer/>
  )
}

export default PayoutsPage